<div *ngFor="let value of values">
    {{ value }}
</div>
